import React from 'react'
import callApi from '../../utils/ApiCall'
import AccountsList from './AccountsList'
import { Link } from 'react-router-dom';
import { prepareAccounts, capitalizeFirstLetter } from '../Helpers'

class Accounts extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isLoadingAccounts: true,
      accounts: []
    }
  }

  async componentDidMount() {
    this.props.setActiveNav('Accounts')
    await this.fetchOpenAccounts()
  }

  async fetchOpenAccounts() {
    const that = this
    let url
    if (this.props.authType === 'Admin') {
      url = `/accounts`
    } else {
      const uuid = this.props.orgUuid
      url = `/organisations/${uuid}/accounts`
    }

    await callApi(url)
      .then(function (response) {
        // console.log(response);
        if (!response.data.accounts) {
          that.setState({ isLoadingAccounts: false })
          return
        }

        const accounts = prepareAccounts(response.data.accounts)
        that.setState({ accounts }, () => {
          that.setState({ isLoadingAccounts: false })
        })
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  render () {
    const { organisation, authType, t } = this.props
    const { accounts, isLoadingAccounts } = this.state

    return (
      <>
        <h1>
          Accounts
        </h1>
        
        <div className='d-flex align-items-center'>
          <ul className="nav nav-pills">
            <li role="presentation" className="nav-item">
              <Link to="/acccounts" className="nav-link active">Open</Link>
            </li>
            <li role="presentation" className="nav-item ">
              <Link to="/accounts/closed" className='nav-link'>
                {capitalizeFirstLetter(t('closed'))}
              </Link>
            </li>
          </ul>

          <Link
            to='/accounts/new'
            className={`ms-auto btn btn-primary${organisation.active ? '' : ' disabled'}`}
          >
            {/* Add new */}
            {capitalizeFirstLetter(t('add new'))}
          </Link>
        </div>

        <br />

        <AccountsList
          isLoadingAccounts={isLoadingAccounts}
          accounts={accounts}
          showBtn={true}
          authType={authType}
          t={t}
        />
      </>
    )
  }
}

export default Accounts
